export const titlePage = tipoDeOperacao => {
  switch (tipoDeOperacao) {
    case 'SUBMISSAO_DADOS':
      return 'Submissão de dados';

    case 'CADASTRO_USUARIO':
      return 'Cadastro de usuário';

    case 'ATUALIZACAO_PERFIL':
      return 'Atualização de perfil';

    case 'REABIR_COMPETENCIA':
      return 'Reabertura de competência';

    case 'ADICAO_LINHA_CUIDADO':
      return 'Adição de Linha de Cuidado';

    case 'EXPORTACAO_DADOS':
      return 'Exportação de dados';

    case 'ATUALIZAO_SUPORTE':
      return 'Atualização de suporte';

    case 'CADASTRO_INSTITUICAO':
      return 'Cadastro de instituição';

    default:
      return null;
  }
};

export const tipoPageDescription = {
  SUBMISSAO_DADOS: 'Resumo de eventos para submissão de Indicadores Gerais',
  CADASTRO_USUARIO: 'Resumo de eventos para cadastros de usuários',
  ATUALIZACAO_PERFIL: 'Resumo de eventos para atualização de perfil',
  REABIR_COMPETENCIA: 'Resumo de eventos para reaberturas de competência',
  ADICAO_LINHA_CUIDADO: 'Resumo de eventos para submissão de Linhas d, Cuidado',
  ADICAO_LINHA_CUIDADO_EXPORTS: 'Resumo de eventos para exportação de dados',
  ATUALIZAO_SUPORTE: 'Resumo de eventos para atualização da área de suporte',
  CADASTRO_INSTITUICAO: 'Resumo de eventos para cadastro de instituição',
};
